import { CheckCircleFilled } from '@ant-design/icons';
import { Tooltip } from '@thndr/design-system';
import * as Styles from './active-plan.styles';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
  MarketName,
  SubscriptionProduct,
} from 'libs/namespace/subscriptions/src/types';
import { usePlanCard } from '../../../../components/plan-card/usePlanCard';
export type ModalState = 'Info' | 'Unsubscribe';
interface IModalProps {
  product: SubscriptionProduct[];
  visibility?: boolean;
  isLoading?: boolean;
  modalState: ModalState;
  onClose?: () => void;
  onCancelSubscription?: () => void;
  market?: MarketName;
}

export function Modal({
  product,
  visibility,
  isLoading,
  modalState,
  onClose,
  onCancelSubscription,
  market,
}: IModalProps) {
  const { t } = useTranslation('subscriptions');
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const { PRODUCT_INFO } = usePlanCard({ market });
  const name = PRODUCT_INFO[product[0]]?.name;

  return (
    <>
      {modalState !== 'Unsubscribe' && (
        <Styles.StyledToolTip
          onClick={() => {
            setIsVisible(true);
          }}
          src="/icons/infoBlue.svg"
        />
      )}
      <Styles.Modal
        modaState={modalState}
        visible={isVisible || visibility}
        centered={true}
        footer={null}
        closable={false}
      >
        <Styles.Flex
          style={{ flexDirection: 'column', justifyContent: 'center' }}
        >
          <Styles.ModalTitle>
            {modalState == 'Info'
              ? t('activeCard.modal.title', {
                  product: t(name),
                })
              : t('activeCard.modal.unsubscribeTitle')}
          </Styles.ModalTitle>
          <Styles.Flex
            style={{ flexDirection: 'column', alignItems: 'flex-start' }}
          >
            {product?.map((item) => {
              const features = PRODUCT_INFO[item]?.features;

              return features?.map((feature) => {
                if (feature.hide) {
                  return null;
                }
                const platforms = feature?.platforms?.map((platform) => {
                  return t(platform);
                });
                return (
                  <Styles.FeatureContainer key={feature.name}>
                    {modalState === 'Info' ? (
                      <CheckCircleFilled
                        style={{ fontSize: '22px', margin: '0px 5px' }}
                      />
                    ) : (
                      <Styles.CloseIcon src="/icons/closeRed.svg" />
                    )}

                    <Styles.FeatureText>{t(feature?.name)}</Styles.FeatureText>
                    <Tooltip
                      title={t(feature?.name)}
                      platforms={platforms}
                      color={item === 'SPARK' ? 'green' : 'yellow'}
                      subtitle={t(feature?.subtitle)}
                      prefix={t('features.prefix')}
                      buttonText={t('button.ok')}
                    />
                  </Styles.FeatureContainer>
                );
              });
            })}{' '}
          </Styles.Flex>
          <Styles.ModalButton
            modaState={modalState}
            loading={isLoading}
            onClick={() => {
              if (onCancelSubscription) {
                onCancelSubscription();
              } else {
                setIsVisible(false);
              }
            }}
          >
            {modalState == 'Info' ? t('button.ok') : t('actions.unsbuscribe')}
          </Styles.ModalButton>
          {modalState == 'Unsubscribe' && (
            <Styles.ModalText onClick={() => onClose()}>
              {t('actions.keep')}
            </Styles.ModalText>
          )}
        </Styles.Flex>
      </Styles.Modal>
    </>
  );
}
